<template>
    <div class="gocc__authentication display--flex page--all background--green--light">
        <base-card class="gocc__authentication__form">
            <template #card__title >
                {{ $t(`authentication.${$route.name}`) }}
            </template>
            <template #card__body >
                <transition
                    name="fade-authentication"
                    mode="out-in"
                    @enter="enter"
                >
                <router-view
                    class="gocc__authentication__form__element"
                    :settings="{
                        id: $route.name,
                        submissionType: submissionTypes[ $route.name ]
                    }"
                    :input="() => import( /* webpackChunkName: 'BaseField' */ '@/components/bundles/fields/BaseField' )"
                    :button="
                        () => import( /* webpackChunkName: 'BaseButton' */ '@/components/bundles/buttons/BaseButton' )
                    "
                />
                </transition>
            </template>
        </base-card>
    </div>
</template>

<script>
// packages
import { reactive, ref, watch } from '@vue/composition-api';

export default {
    components: {
        BaseCard: () => import( /* webpackChunkName: 'BaseCard' */ '@/components/bundles/cards/BaseCard' )
    },
    setup ( _, { root }) {
        // obtenção & update da route.
        const route = ref( root.$route.name );
        const previousRoute = ref();

        watch( () => root.$route,
            newRoute => {
                route.value = newRoute.name;
                previousRoute.value = newRoute.name === 'login' ? 'forgot' : 'login';
            });

        // animação de transição de página.
        const enter = element => {
            // definção dos valores default de cada página.
            const heights = {
                login: {
                    attribute: 'maxHeight',
                    value: '228px'
                },
                forgot: {
                    attribute: 'minHeight',
                    value: '174px'
                },
                reset: {
                    attribute: 'minHeight',
                    value: '223px'
                }
            };

            // obtenção dos valores da página actual.
            const { attribute, value } = heights[route.value];

            // definição do atributo com o valor da rota anterior.
            element.style[attribute] = heights[previousRoute.value]?.value;

            // definição do atributo com o valor da rota actual.
            setTimeout( () => { element.style[attribute] = value; });
        };

        // tipos de submissão conforma a páginas.
        const submissionTypes = reactive({
            login: 'processLogin',
            reset: 'resetPassword',
            forgot: 'forgotPassword'
        });

        return {
            submissionTypes,
            enter
        };
    }
};

</script>

<style lang="scss">
    // =============================================================================
    // Animations
    // =============================================================================
    .fade-authentication-enter-active {
        @include transition(
            opacity .3s ease-in-out .15s,
            min-height .3s ease-in-out,
            max-height .3s ease-in-out
        );
        overflow: hidden;
    }

    .fade-authentication-enter,
    .fade-authentication-leave-active {
        opacity: 0
    }

    // =============================================================================
    // Style
    // =============================================================================
    .gocc {
        &__authentication {
            @include position-grid( center, center );
            flex-direction: column;
            &__form {
                max-width: 400px;
                &__field {
                    &:not(:last-child) {
                        margin-bottom: 10px;
                    }
                    &__input {
                        height: 45px;
                    }
                    &--margin {
                        margin-top: 25px;
                    }
                }
                &__anchor {
                    text-align: center;
                    @include typography-specs( 16px, 24px );
                    margin-bottom: 25px;
                }
                &__back {
                    margin: 5px 0 0;
                }
            }
        }
    }
</style>